import { IdentityImage } from "./IdentityImage";
import { colorForId, initials } from "@/lib/colors";

export function AvatarChip({
  id,
  name,
  size = 20,
  title,
  image,
  avatarUrls,
}: {
  id: string;
  name: string;
  size?: number;
  title?: string;
  image?: string | null;
  avatarUrls?: string[];
}) {
  return (
    <span
      className="avatar-chip"
      style={{
        overflow: "hidden",
        position: "relative",
        background: colorForId(id),
        width: size,
        height: size,
        fontSize: Math.max(9, size * 0.45),
      }}
      title={title ?? name}
    >
      {initials(name)}
      <IdentityImage image={image} avatarUrls={avatarUrls} />
    </span>
  );
}
